var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlashCircle = function SvgFlashCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#16A34A",
    d: "M19.95 3.334C10.75 3.334 3.283 10.8 3.283 20S10.75 36.667 19.95 36.667 36.617 29.2 36.617 20 29.167 3.334 19.95 3.334m6.25 17.25-6.2 7.05-.733.833c-1.017 1.15-1.85.85-1.85-.7v-6.6h-2.834c-1.283 0-1.633-.784-.783-1.75l6.2-7.05.733-.834c1.017-1.15 1.85-.85 1.85.7v6.6h2.834c1.283 0 1.633.784.783 1.75"
  })));
};
export default SvgFlashCircle;